<ion-item button detail="false" class="result-item" (click)="onClick()">
  <ion-label class="result-container">
    <span class="dni">{{ dniDisplay }}</span>
    <span class="fullname">{{ user.fullname }}</span>
    <span class="email">{{ emailDisplay }}</span>
  </ion-label>
</ion-item>
